module.exports = __webpack_public_path__ + "static/media/facebook.e4e9a217.svg";